export const CLEAN_FORM_CONFIRM_TEXT = 'Вы уверены, что хотите удалить всю ' +
    'сохраненную информацию по причинам для данной строки?';
